module.exports = __webpack_public_path__ + "static/media/tab_3.6b932c62.png";